import { createFileRoute } from "@tanstack/react-router"

import { MarketingMailingFormPage } from "@/pages/marketing-mailing-form"

export const Route = createFileRoute("/(marketing)/marketing/mailings/new")({
	staticData: {
		breadcrumbKey: "navigation.breadcrumbs.mailingCreate",
	},
	component: () => <MarketingMailingFormPage mode="create" />,
})
